<!--

  @copyright Copyright (c) Open-Xchange GmbH, Germany <info@open-xchange.com>
  @license AGPL-3.0

  This code is free software: you can redistribute it and/or modify
  it under the terms of the GNU Affero General Public License as published by
  the Free Software Foundation, either version 3 of the License, or
  (at your option) any later version.

  This program is distributed in the hope that it will be useful,
  but WITHOUT ANY WARRANTY; without even the implied warranty of
  MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE. See the
  GNU Affero General Public License for more details.

  You should have received a copy of the GNU Affero General Public License
  along with OX App Suite. If not, see <https://www.gnu.org/licenses/agpl-3.0.txt>.

  Any use of the work other than as authorized under this license or copyright law is prohibited.

-->

<template>
  <div class="fulltime-container scrollable" data-test="all-day">
    <div class="appointment-panel grid min-h-0" tabindex="0">
      <Appointment
        v-for="appointment in appointments"
        :key="cid(appointment)"
        :appointment="appointment"
        :dateRef="dateRef"
        :isFullDay="true"
      ></Appointment>
    </div>
  </div>
</template>

<script setup>
import { computed } from 'vue'
import { useCalendarStore } from '@/io.ox/calendar/calendar-store'
import Appointment from '@/io.ox/calendar/week/day-appointment.vue'
import { cid } from '@/io.ox/calendar/util'

const { dateRef } = defineProps({
  dateRef: { type: Object, required: true }
})

const store = useCalendarStore()

const appointments = computed(() => {
  const key = dateRef.toISODate()
  // filter full day appointments
  return Object.values(store.appointmentsByDay[key] || {})
    .filter(appointment => !appointment.startDate.value.includes('T'))
})
</script>

<style lang="scss">
.fulltime-container .appointment-panel .appointment .appointment-content {
  display: flex;
  align-items: center;
  .title-container {
    display: flex;
    margin-inline-end: auto;
    svg { flex-shrink: 0; }
  }
  .location { display: none; }
  .flags.bottom-right {
    position: static;
    flex-shrink: 0;
  }
}
</style>

<style lang="scss" scoped>
.fulltime-container {
  min-height: 0;
  max-height: var(--full-day-container-max-height, 60px);
  // without flex-shrink the container still gets squeezed
  flex-shrink: 0;
  padding: 0 var(--weekview-trailing-space) 0px calc(var(--weekview-time-column-gap) + var(--weekview-time-column-width));
  .appointment-panel {
    border: unset;
    grid-template-columns: repeat(2, 1fr);
    column-gap: 2px;
    .appointment {
      position: static;
      height: 20px;
      margin-bottom: 2px;
      min-width: 100%;
      &:last-child:nth-child(odd) { grid-column: span 2; }
    }
  }
}
.smartphone .weekview-container .appointment-container .appointment {
  min-height: 22px;
}
</style>
